import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row } from 'antd';

import ListingWizardLayout from 'layouts/ListingWizardLayout/ListingWizardLayout';
import FormInput from 'components/FormInput/FormInput';

import styles from './Description.module.css';
import intl from 'react-intl-universal';

class Description extends React.Component {
  handleOnSubmit = e => {
    e.preventDefault();
    const { form, onSave } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onSave(values);
      }
    });
  };

  handleOnBackClick = e => {
    e.preventDefault();
    const { form, onBack } = this.props;
    const allFieldsValue = form.getFieldsValue();
    onBack(allFieldsValue);
  };

  render() {
    const { defaultValues, form, isLastPage, percentage, title } = this.props;
    return (
      <ListingWizardLayout
        isLastPage={isLastPage}
        percentage={percentage}
        title={title}
        onBackButtonClick={this.handleOnBackClick}
        onNextButtonClick={this.handleOnSubmit}
      >
        <Row type="flex" justify="space-between" className={styles.formTitleContainer}>
          <h2 className={styles.formTitle}>{intl.get('listings.unit.headerLabels.descUnit').d('Describe your unit')}</h2>
          <p>{intl.get('listings.unit.headerLabels.descUnitDetail').d('Provide a detailed description of your unit')}</p>
        </Row>

        <FormInput
          inputType="textarea"
          label={intl.get('listings.unit.headerLabels.summary').d('Summary')}
          name="summary"
          placeholder={intl.get('listings.unit.placeholder.unitDesc').d('Describe your unit in general')}
          requiredErrorMessage={intl.get('listings.unit.placeholder.unitDescMsg').d('Please provide a summary of your unit')}
          form={form}
          defaultValue={defaultValues.summary}
          size="large"
        />

        <FormInput
          inputType="textarea"
          label={intl.get('listings.unit.headerLabels.aboutUnit').d('About your unit')}
          name="aboutYourPlace"
          placeholder={intl.get('listings.unit.placeholder.aboutUnit').d('Describe your unit')}
          requiredErrorMessage={intl.get('listings.unit.placeholder.aboutUnitMsg').d('Please provide a description of your unit')}
          form={form}
          defaultValue={defaultValues.aboutYourPlace}
          size="large"
        />

        <FormInput
          inputType="textarea"
          label={intl.get('listings.unit.headerLabels.neighborhood').d('About your neighbourhood')}
          name="aboutYourNeighbourhood"
          placeholder={intl.get('listings.unit.placeholder.neighborhood').d('Describe the neighbourhood of your unit')}
          requiredErrorMessage={intl.get('listings.unit.placeholder.neighborhoodMsg').d('Describe the neighbourhood of your unit')}
          form={form}
          defaultValue={defaultValues.aboutYourNeighbourhood}
          size="large"
        />

        <FormInput
          inputType="textarea"
          label={intl.get('listings.unit.headerLabels.gettingHere').d('Getting Here')}
          name="transit"
          placeholder={intl.get('listings.unit.placeholder.gettingHere').d('Describe how a guest can reach your unit')}
          requiredErrorMessage={intl
            .get('listings.unit.placeholder.gettingHereMsg')
            .d('Please provide a description of how a guest can reach your unit')}
          form={form}
          defaultValue={defaultValues.transit}
          size="large"
        />

        <FormInput
          inputType="textarea"
          label={intl.get('listings.unit.headerLabels.access').d('Access your place')}
          name="access"
          placeholder={intl.get('listings.unit.placeholder.access').d('Describe what accessibility features are available at your unit')}
          form={form}
          defaultValue={defaultValues.access}
          size="large"
        />

        <FormInput
          inputType="textarea"
          label={intl.get('listings.unit.headerLabels.note').d('Things to take note')}
          name="notes"
          placeholder={intl.get('listings.unit.placeholder.note').d('List important things for your guest to know about your unit')}
          form={form}
          defaultValue={defaultValues.notes}
          size="large"
        />

        <FormInput
          inputType="textarea"
          label={intl.get('listings.unit.headerLabels.rule').d('House rules')}
          name="houseRules"
          placeholder={intl.get('listings.unit.placeholder.rule').d('List the house rules for your unit')}
          form={form}
          defaultValue={defaultValues.houseRules}
          size="large"
        />

        <FormInput
          inputType="textarea"
          label={intl.get('listings.unit.headerLabels.interaction').d('Your interaction with guests')}
          name="interaction"
          placeholder={intl.get('listings.unit.placeholder.interaction').d('Greet your guest!t')}
          form={form}
          defaultValue={defaultValues.interaction}
          size="large"
        />
      </ListingWizardLayout>
    );
  }
}

Description.propTypes = {
  form: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  percentage: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  defaultValues: PropTypes.object,
  isLastPage: PropTypes.bool,
  onBack: PropTypes.func
};

Description.defaultProps = {
  defaultValues: {},
  isLastPage: false
};

const WrappedFormDescription = Form.create()(Description);

export default WrappedFormDescription;
